import { render } from "./RDFResults.vue?vue&type=template&id=1faf9a9a&scoped=true"
import script from "./RDFResults.vue?vue&type=script&lang=js"
export * from "./RDFResults.vue?vue&type=script&lang=js"

import "./RDFResults.vue?vue&type=style&index=0&id=1faf9a9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faf9a9a"]])

export default __exports__